export default __webpack_public_path__ + "static/media/half-circle.77f5fada.png";